import { AiResponseReviewRating } from "@app/operations/ai-response-review/enums";

export const formatRating = (rating?: AiResponseReviewRating): string => {
  switch (rating) {
    case AiResponseReviewRating.Good:
      return "Good";
    case AiResponseReviewRating.Bad:
      return "Bad";
    case AiResponseReviewRating.None:
      return "-";
    default:
      return "-";
  }
};
